import { capitalizeFirstLetter, translateCountry } from '../../../../../attendee/detail/components/utils';
export const NON_CONTENT_FIELD_TYPES = ['file', 'divider'];
export const formatForm = (form, t, locale) => {
    if (!form) {
        return [];
    }

    return form
        .filter(entry => !NON_CONTENT_FIELD_TYPES.includes(entry.field_type))
        .sort((a, b) => a.order - b.order)
        .map(formEntry => {
            let answer;
            switch (formEntry.field_type) {
                case 'country':
                    answer = capitalizeFirstLetter(translateCountry(locale, formEntry.answer));
                    break;
                case 'checkbox':
                    answer = ['True', '1'].includes(formEntry.answer) ? t('ticket.common.yes') : t('ticket.common.no');
                    break;
                default:
                    answer = formEntry.answer?.replace('None', '');
            }
            return {
                text: answer || '',
                ...formEntry
            };
        });
};
